// modalOccActions.js
export const OPEN_MODAL_OCC = "OPEN_MODAL_OCC";
export const CLOSE_MODAL_OCC = "CLOSE_MODAL_OCC";

export const openModalOcc = (modalType) => ({
  type: OPEN_MODAL_OCC,
  payload: modalType,
});

export const closeModalOcc = () => ({
  type: CLOSE_MODAL_OCC,
});
